/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeValidationRpc
 */

export const AssetCoordinatesDiscriminantKey = '@c';
export const CompositeTargetingConfigTypename = 'com.hubspot.personalize.models.CompositeTargetingConfig';
export const CompositeTargetingConfigDiscriminant = 'COMPOSITE';
export const CompositeTargetingConfigDiscriminantKey = 'type';
export const CrmObjectTargetingConfigTypename = 'com.hubspot.personalize.models.CrmObjectTargetingConfig';
export const CrmObjectTargetingConfigDiscriminant = 'CRM_OBJECT';
export const CrmObjectTargetingConfigDiscriminantKey = 'type';
export const LandingPageCoordinatesTypename = 'com.hubspot.personalize.models.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminant = '.LandingPageCoordinates';
export const LandingPageCoordinatesDiscriminantKey = '@c';
export const MarketingEmailCoordinatesTypename = 'com.hubspot.personalize.models.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminant = '.MarketingEmailCoordinates';
export const MarketingEmailCoordinatesDiscriminantKey = '@c';
export const SegmentTargetingConfigTypename = 'com.hubspot.personalize.models.SegmentTargetingConfig';
export const SegmentTargetingConfigDiscriminant = 'SEGMENT';
export const SegmentTargetingConfigDiscriminantKey = 'type';
export const TargetingConfigDiscriminantKey = 'type';
export const WebInteractiveCoordinatesTypename = 'com.hubspot.personalize.models.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminant = '.WebInteractiveCoordinates';
export const WebInteractiveCoordinatesDiscriminantKey = '@c';
export const WebsitePageCoordinatesTypename = 'com.hubspot.personalize.models.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminant = '.WebsitePageCoordinates';
export const WebsitePageCoordinatesDiscriminantKey = '@c';
export const validatePersonalizationPrerequisitesRpc = {
  serviceName: 'com.hubspot.personalize.rpc.PersonalizeValidationRpc',
  rpcName: 'validatePersonalizationPrerequisites',
  auth: 'app',
  fingerprint: 'yiRKnXxrRKCdP3ASf9n9Qg6OTna_sRfZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};